import { SessionWithId } from '../Models/session';

export const sortAndFilterSessions = (
    sessions: SessionWithId[],
): SessionWithId[] => {
    const currentDate = new Date();

    const isSameDate = (date1: Date, date2: Date): boolean => {
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
        );
    };

    // Filter sessions that are today or in the future
    const filteredSessions = sessions.filter((sessionWithId) => {
        const sessionDate = new Date(
            sessionWithId.session.year,
            sessionWithId.session.month - 1, // Month is 0-based in JavaScript Date
            sessionWithId.session.day,
            sessionWithId.session.hour,
            sessionWithId.session.minute,
        );

        return (
            isSameDate(sessionDate, currentDate) || sessionDate > currentDate
        );
    });
    // Sort the filtered sessions by date
    filteredSessions.sort((a, b) => {
        const dateA = new Date(
            a.session.year,
            a.session.month - 1, // Month is 0-based in JavaScript Date
            a.session.day,
            a.session.hour,
            a.session.minute,
        ).getTime();

        const dateB = new Date(
            b.session.year,
            b.session.month - 1, // Month is 0-based in JavaScript Date
            b.session.day,
            b.session.hour,
            b.session.minute,
        ).getTime();

        return dateA - dateB;
    });

    return filteredSessions;
};
